'use client';

import { FC, forwardRef, ReactNode } from 'react';
import { cn } from 'utils/tw';

interface ICardProps extends React.HTMLProps<HTMLDivElement> {
  children: ReactNode;
  // subHeader: ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

export const Card = forwardRef<HTMLDivElement, ICardProps>(
  ({ children, ...props }, ref) => {
  return (
    <div
      className="relative"
      ref={ref}
      style={{ height: 'max-content' }}
    >
      <div className={cn(
        'flex flex-col gap-2 rounded-2xl bg-white',
        // TODO: test if ok without border and del from codebase
        // 'border border-white hover:border-brand-200',
        'hover:shadow-xl hover:w-full hover:z-10 duration-300',
        props.className
      )}
           style={props.style}
      >
        {children}
      </div>
    </div>
  );
});

Card.displayName = 'Card'

interface ICardHeaderProps {
  children: ReactNode;
  className?: string;
}

export const CardHeader: FC<ICardHeaderProps> = ({ children, className = '' }) => {
  return (
    <div className={`p-4 border-b border-b-gray-100 mb-2 flex justify-between items-center ${className}`}>
      {children}
    </div>
  );
};

interface ICardContentProps {
  children: ReactNode;
  className?: string;
}

export const CardContent: FC<ICardContentProps> = ({ children, className }) => {
  return (
    <div className={cn('px-4 pb-4', className)}>
      {children}
    </div>
  );
};

interface ICardFooterProps {
  children: ReactNode;
  className?: string;
}

export const CardFooter: FC<ICardFooterProps> = ({ children, className = '' }) => {
  return (
    <div className={`p-4 border-t border-t-gray-100 flex justify-between items-center ${className}`}>
      {children}
    </div>
  );
};